import { ComponentType, SVGProps } from "react";
import {
  SiJavascript,
  SiTypescript,
  SiOpenjdk,
  SiPhp,
  SiReact,
  SiNextdotjs,
  SiSvelte,
  SiRedux,
  SiLit,
  SiJquery,
  SiTailwindcss,
  SiGit,
  SiMysql,
  SiStorybook,
} from "react-icons/si";
import { SkillEntry } from "./skills";

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

const simpleIcons: Record<string, IconComponent> = {
  SiJavascript,
  SiTypescript,
  SiOpenjdk,
  SiPhp,
  SiReact,
  SiNextdotjs,
  SiSvelte,
  SiRedux,
  SiLit,
  SiJquery,
  SiTailwindcss,
  SiGit,
  SiMysql,
  SiStorybook,
};

export function getSkillIcon(entry: SkillEntry): IconComponent | undefined {
  return simpleIcons[entry.iconName];
}
